var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), 'sw-typo-default', 'scrollbar--dark',
    ( _obj = {}, _obj[(_vm.cssPrefix + "--compact")] = _vm.compact, _obj )
  ]},[_c('div',{class:[(_vm.cssPrefix + "__inner")],style:(_vm.innerStyle)},[_vm._t("default")],2),_vm._v(" "),_c('div',{class:[(_vm.cssPrefix + "__arrow")],attrs:{"x-arrow":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }